(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pathway-customer-portal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pathway-kit-portal')) {
    customElements.define('pathway-kit-portal', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.pcp-form');
        this.input = this.querySelector('input[name="kitId"]');
        this.button = this.querySelector('button[type="submit"]');
        this.message = this.querySelector('[data-portal-message]');
        this.loading = this.querySelector('[data-kit-loading]');
        this.empty = this.querySelector('[data-kit-empty]');
        this.list = this.querySelector('[data-kit-list]');
        this.count = this.querySelector('[data-kit-count]');
        this.csrfToken = '';
        this.form?.addEventListener('submit', (event) => this.registerKit(event));
        this.loadKits();
      }

      async request(options = {}) {
        const response = await fetch(this.dataset.apiPath, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          ...options,
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || this.dataset.errorLabel);
        return payload;
      }

      async loadKits() {
        this.loading.hidden = false;
        this.empty.hidden = true;
        this.list.hidden = true;
        try {
          const payload = await this.request();
          this.csrfToken = payload.csrfToken || '';
          this.renderKits(Array.isArray(payload.kits) ? payload.kits : []);
          this.button.disabled = !this.csrfToken;
          this.button.textContent = this.dataset.submitLabel;
          this.setMessage('');
        } catch (error) {
          this.loading.hidden = true;
          this.button.disabled = true;
          this.setMessage(error.message || this.dataset.errorLabel, true);
        }
      }

      statusLabel(status) {
        const key = String(status || 'assigned').replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
        return this.dataset[`status${key.charAt(0).toUpperCase()}${key.slice(1)}`] || this.dataset.statusAssigned;
      }

      renderKits(kits) {
        this.loading.hidden = true;
        this.count.textContent = String(kits.length);
        this.list.replaceChildren();
        if (!kits.length) {
          this.empty.hidden = false;
          this.list.hidden = true;
          return;
        }
        this.empty.hidden = true;
        kits.forEach((kit) => {
          const record = document.createElement('article');
          record.className = 'pcp-kit-record';
          const identity = document.createElement('div');
          const label = document.createElement('small');
          label.textContent = this.dataset.kitIdLabel;
          const kitId = document.createElement('strong');
          kitId.textContent = kit.kitId || '';
          identity.append(label, kitId);
          const status = document.createElement('span');
          status.className = 'pcp-kit-status';
          status.textContent = this.statusLabel(kit.status);
          const date = document.createElement('time');
          date.className = 'pcp-kit-date';
          if (kit.registeredAt) {
            date.dateTime = kit.registeredAt;
            date.textContent = `${this.dataset.registeredPrefix} ${new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' }).format(new Date(kit.registeredAt))}`;
          }
          record.append(identity, status, date);
          this.list.append(record);
        });
        this.list.hidden = false;
      }

      setMessage(message, isError = false) {
        this.message.textContent = message || '';
        this.message.classList.toggle('is-error', Boolean(message && isError));
      }

      async registerKit(event) {
        event.preventDefault();
        if (!this.form.reportValidity() || !this.csrfToken) return;
        this.button.disabled = true;
        this.button.textContent = this.dataset.submittingLabel;
        this.setMessage('');
        try {
          await this.request({
            method: 'POST',
            body: JSON.stringify({ kitId: this.input.value, csrfToken: this.csrfToken }),
          });
          this.form.reset();
          this.setMessage(this.dataset.successLabel);
          await this.loadKits();
          this.setMessage(this.dataset.successLabel);
        } catch (error) {
          this.setMessage(error.message || this.dataset.errorLabel, true);
        } finally {
          this.button.disabled = !this.csrfToken;
          this.button.textContent = this.dataset.submitLabel;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
